export var EMAIL_MAX_CHARACTERS = 255;
export var FIRST_NAME_MAX_CHARACTERS = 80;
export var LAST_NAME_MAX_CHARACTERS = 80;